import { updateInitialConfig, updateModifiedConfig } from "../checksumStore";

export const updateActivityChecksum = (activityData, isInit = false) => {
  let storeConfig = {
    activity_owner_assignment: activityData.activity_owner_assignment,
    state_change_logic: activityData.state_change_logic || [],
    jobs_trigger: activityData.jobs_trigger || [],
    pre_activity_job: activityData.pre_activity_job || [],
    jobs_trigger_formula: activityData.jobs_trigger_formula || "",
    activity_change_logic: activityData.activity_change_logic || [],
    pre_submission: activityData.pre_submission || [],
    activity_response: activityData.activity_response || [],
    description: activityData.description || "",
    type: activityData.type || "default",
    sort_by: activityData.sort_by,
    allowed_count: activityData.allowed_count || 0,
    positions: activityData?.positions || {},
    gateway_change_logic: activityData.gateway_change_logic || []
  };
  if (isInit) {
    updateInitialConfig(storeConfig);
  } else {
    updateModifiedConfig(storeConfig);
  }
  return storeConfig;
};
